/*
 MapMarkerManager Module
 */

import MapMarker from './objects/mapMarker.js'

const MapMarkerManager = (function(MapMarker) {
    // ================== VARIABLE ================== //
    var _searchMap = undefined;
    var _markerList = {};
    var _renderToken = 0;

    // ================== CONSTRUCTOR ================== //
    function MapMarkerManager() {
        // Singleton
        if (MapMarkerManager.instance) {
            throw new Error('MapMarkerManager is a singleton. Use MapMarkerManager.instance.');
        }
        // enforces new
        if (!(this instanceof MapMarkerManager)) {
            return new MapMarkerManager();
        }
    };

    // ================== PUBLIC METHOD ================== //
    MapMarkerManager.prototype.renderMarkers = function(rowCruiseList, sharingType) {

        if (_searchMap == undefined)
            return;

        _renderToken += 1;
        var currentToken = _renderToken;
        var portId;
        var portList = _getPortList(rowCruiseList);

        // Clear map
        _searchMap.deleteMarkers(portList);
        if ($('#id_longitude_sw').val() == "")
            _searchMap.fitMapToMarkers(portList);

        function onMarkerReady(marker) {
            if (currentToken == _renderToken)
                marker.display(_searchMap, sharingType);
        }

        for (var i = portList.length - 1; i >= 0; i--) {
            portId = 'port-' + portList[i].id;
            if (_markerList[portId] == undefined)
                _markerList[portId] = new MapMarker(portList[i]);
            _markerList[portId].updateCruiseList(portList[i].cruise_list, onMarkerReady);
        }
    };

    MapMarkerManager.prototype.setSearchMap = function(searchMap) {
        _searchMap = searchMap;
    };

    // ================== PRIVATE METHOD ================== //
    function _compute_marker_data(rowCruiseList) {
        var result = {};
        for (var i = 0; i < rowCruiseList.length; i++) {
            var m_id = 'port-' + rowCruiseList[i].starting_port.id;
            if (result[m_id] == undefined)
                result[m_id] = {
                    'id': rowCruiseList[i].starting_port.id,
                    'cruise_list': [],
                    'pos': {
                        'lat': rowCruiseList[i].starting_port.latitude,
                        'lng': rowCruiseList[i].starting_port.longitude
                    }
                };
            result[m_id].cruise_list.push(rowCruiseList[i].id);
        };
        return result;
    }

    function _getPortList(rowCruiseList) {
        var portId, portObject;
        var result = [];
        result.get = function(id) {
            for (var i = this.length - 1; i >= 0; i--)
                if (this[i].id == id)
                    return this[i];
            return undefined;
        }

        for (var i = 0; i < rowCruiseList.length; i++) {
            portObject = result.get(rowCruiseList[i].starting_port.id);
            if (portObject == undefined) {
                portObject = {
                    'id': rowCruiseList[i].starting_port.id,
                    'cruise_list': [],
                    'pos': {
                        'lat': rowCruiseList[i].starting_port.latitude,
                        'lng': rowCruiseList[i].starting_port.longitude
                    }
                };
                result.push(portObject);
            }
            portObject.cruise_list.push(rowCruiseList[i].id);
        };
        return result;
    }

    MapMarkerManager.instance = new MapMarkerManager();

    return MapMarkerManager.instance;
})(MapMarker);

export default MapMarkerManager


// WEBPACK FOOTER //
// ./search/static/search/js/mapMarkerManager.js